import styled, { css } from 'styled-components'
import { truncateStyles } from 'components/Truncate'
import { breakpoint } from 'utils'

const ModalHeader = styled.h1(
  ({ theme }) => css`
    margin: 0;
    padding: 16px 16px 4px;

    ${breakpoint('sm')`
      padding: 32px 32px 4px;
    `}

    text-transform: none;
    word-break: break-word;
    color: inherit;
    display: block;

    font-size: ${theme.fontSizes.large};
    font-weight: ${theme.fontWeights.bold};
    line-height: 1.6;

    span {
      display: block;
    }

    small {
      ${truncateStyles};

      display: inline-block;
      font-weight: ${theme.fontWeights.regular};
      color: ${theme.colors.foreground.secondary[3]};
      background-color: ${theme.colors.border.dark.base};
      line-height: 1.5;
      padding: 0 8px;
      vertical-align: top;
      margin-top: 4px;
      border-radius: 3px;
      max-width: 100%;
    }
  `
)

export default ModalHeader
